<template lang="html">
  <div class="homePage">
    <div class="informerBtn" @click="informerShow = 1">
      <p>一键举报</p>
    </div>

    <img class="homePoster" :src="`${pagebase}/static/img/assistance/back.png`" alt="">

    <div class="content">
      <img :src="`${pagebase}/static/img/assistance/conImg_1.png`" alt="" class="conImg">
      <img :src="`${pagebase}/static/img/assistance/conImg_2.png`" alt="" class="conImg">
      <div class="conBtn">
        <div class="liveStreamingBtn" v-if="activityType" :style="{backgroundImage: 'url('+ `${pagebase}/static/img/assistance/button1.png` +')'}" @click.capture="loginCardShow = true, getShowStat(1)">
          云上观展

          <WxOpenTag ref="wxopentag" :extinfo="'live/detail?url=' + activityUrl" v-show="getInfo" />
        </div>

        <div class="liveStreamingBtn" @click="addGroupShow = 1, getShowStat(4)" v-else :style="{backgroundImage: 'url('+ `${pagebase}/static/img/assistance/button_1.png` +')'}">
          芯片国产化<br>交流群
        </div>

        <div class="giftBtn" :class="{giftBtnType: giftType}" :style="{backgroundImage: 'url('+ `${pagebase}/static/img/assistance/button_2.png` +')'}" @click="goGift">
          <img :src="`${pagebase}/static/img/assistance/icon.png`" alt="">
          免费领实物礼品
        </div>
      </div>
    </div>

    <div class="loginCard" v-show="loginCardShow" @click.self="loginCardShow = false">
      <div class="loginCon" :style="{backgroundImage: 'url('+ `${pagebase}/static/img/assistance/hint1.png` +')'}">
        <input type="number" class="phoneInput" placeholder="请输入手机号领奖品" name="phoneInput" v-model="phone">
        <div class="securityCodeInput">
          <input type="text" placeholder="小小验证码" name="securityCode" v-model="smsCode">
          <p @click="getSmsCode">{{buttonMsg}}</p>
        </div>

        <div class="beginBtn" @click="goLogin">
          开始
        </div>
      </div>
    </div>

    <div class="informerHint" v-show="informerShow == 1" @click.self="informerShow = 0">
      <div class="informerCon">
        <p class="informerInfo">已收到您的反馈，客服会尽快<br>与您取得联系</p>
        <p class="informerClose" @click="informerShow = 0">我知道了</p>
      </div>
    </div>

    <div class="addGroupHint" v-show="addGroupShow == 1" @click="addGroupShow = 0">
      <div class="groupCon">
        <div>扫码进群</div>
        <img :src="`${pagebase}/static/img/assistance/qrCode.png`" alt="">
        <p>半导体&硬件&PCB&射频等多行业大咖交流群</p>
        <p>进群享受电子人共享通讯录</p>
        <p>与大咖资源共享</p>
      </div>
    </div>

    <div class="callApp" @click.capture="getShowStat(3)">
      <img :src="`${pagebase}/static/img/assistance/callapp.png`" alt="">
      <WxOpenTag ref="wxopentag" :extinfo="'native/current'" />
    </div>
  </div>
</template>

<script>
  import utils from '@/utils/utils.js';
  import {
    pagebase
  } from '@/utils/http.js';
  import '@/utils/rem'
  import Cookies from 'js-cookie';
  import WxOpenTag from '@/components/WxOpenTag'
  import WxShare from '@/utils/wxshare'

  export default {
    data() {
      return {
        activityType: this.$route.query.type || '',
        aid: '',
        pagebase: pagebase,
        loginCardShow: false,
        activityUrl: '',
        getInfo: false,
        informerShow: 0,
        addGroupShow: 0,
        giftType: false,

        phone: '',
        smsCode: '',
        limitTime: 60,
        buttonMsg: '发送验证码',
      }
    },

    components: {
      WxOpenTag: WxOpenTag,
    },

    mounted() {
      if(!window.location.port && utils.browserChecker.isWx()){
        this.$router.push({
          path: '/error',
        })
      }
      document.title = '电巢读书月 专家荐好书';
      this.getShowStat(0);
      this.getGiftType();
      // 注册打开app组件
      if (utils.browserChecker.isWx()) {
        this.$refs.wxopentag.register()
      }

      // 直播间
      this.getLiveUrl();

      new WxShare().share({
        title: '快来一起免费领半导体行业桌垫/京东E卡购书金吧！',
        desc: '和HW工程师解封绝密技术资料！',
        link: window.location.href,
        imgUrl: pagebase + '/static/img/assistance/breviaryImg.png'
      });
    },

    methods: {
      // 页面浏览量统计
      getShowStat(id) {
        // var channel = this.$route.query.channel || '';
        // var activityId = this.$route.query.activityId || '';
        this.$http.get('/api/showStat', {
          params: {
            url: window.location.href,
            type: id,
          }
        })
      },

      getGiftType() {
        setInterval(() => {
          this.giftType = true;
        }, 500)
        setInterval(() => {
          this.giftType = false;
        }, 1000)
      },

      // 获取直播地址
      getLiveUrl() {
        this.$http({
          url: '/activity/detail',
          method: 'get',
          params: {
            activity_id: this.$route.query.activityId,
          },
        }).then((res) => {
          if (res.code >= 0) {
            this.activityUrl = res.data.live_url;
            if (Cookies.get('uid') && Cookies.get('token')) {
              this.getInfo = true;
            } else {
              this.getInfo = false;
            }
          }
        })
      },

      // 跳转奖品页
      goGift() {
        this.getShowStat(2);
        if (Cookies.get('uid') && Cookies.get('token')) {
          if (this.activityType) {
            this.$router.push({
              path: '/assistanceInvite',
              query: {
                activityId: this.$route.query.activityId,
                channel: this.$route.query.channel,
                type: this.activityType,
              }
            })
          } else {
            this.$router.push({
              path: '/assistanceInvite',
              query: {
                activityId: this.$route.query.activityId,
                channel: this.$route.query.channel,
              }
            })
          }

        } else {
          this.loginCardShow = true;
        }
      },

      // 获取验证码
      getSmsCode() {
        this.$http.get('/Registered/getPhoneSmsCode', {
          params: utils.cso({
            phone: this.phone,
            phone_head: 86,
            type: 10,
            client: 'H5'
          })
        }).then((res) => {
          if (res.code >= 0) {
            this.buttonMsg = this.limitTime + 's'
            this.timer = window.setInterval(() => {
              this.limitTime--
              this.buttonMsg = this.limitTime + 's'
              if (this.limitTime < 0) {
                window.clearInterval(this.timer)
                this.buttonMsg = '发送验证码'
                this.limitTime = 60
              }
            }, 1000)
          } else {
            utils.showMessage(res.msg)
          }
        })
      },

      // 确定登录
      goLogin() {
        if (this.phone) {
          if (this.smsCode) {
            this.$http({
              url: '/member/joinActivity',
              method: 'post',
              params: {
                phone: this.phone,
                sms_code: this.smsCode,
                type: 0,
                live_activity_id: this.$route.query.activityId,
              },
            }).then((res) => {
              if (res.code >= 0) {
                Cookies.set('uid', res.data.uid, {
                  expires: 7
                });
                Cookies.set('token', res.data.token.token, {
                  expires: 7
                });
                Cookies.set('reg_channel', res.data.reg_channel, {
                  expires: 7
                });
                Cookies.set('aid', res.data.activity_reg_id, {
                  expires: 7
                });
                Cookies.set('phone', this.phone, {
                  expires: 7
                });
                this.loginCardShow = false;
                this.getLiveUrl();
              } else {
                utils.showMessage(res.msg)
              }
            })
          } else {
            utils.showMessage('输入的验证码不能为空')
          }
        } else {
          utils.showMessage('输入的手机号不能为空')
        }
      },
    }
  }
</script>

<style lang="css" scoped>
  .homePage {
    box-sizing: border-box;
    width: 100%;
    height: 97.5rem;
    background-size: contain;
    background-repeat: no-repeat;
    background: linear-gradient(#130958, #160D49);
    position: relative;
  }

  .informerBtn {
    position: absolute;
    top: 1.5rem;
    right: 0;
    display: flex;
    justify-content: flex-end;
  }

  .informerBtn p {
    width: 8rem;
    height: 2.5rem;
    background-color: rgba(255, 255, 255, 0.5);
    font-size: 1.4rem;
    color: #C9F7F7;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2.5rem 0 0 2.5rem;
  }

  .homePoster {
    width: 100%;
  }

  .content {
    width: 100%;
    box-sizing: border-box;
    padding: 0 1.2rem;
    padding-bottom: 1.9rem;
  }

  .conImg {
    width: 100%;
    margin-top: 1.5rem;
  }

  .conBtn {
    box-sizing: border-box;
    padding: 0 .9rem;
    display: flex;
    justify-content: space-between;
    margin-top: 1rem;
  }

  .liveStreamingBtn {
    position: relative;
    width: 13.5rem;
    height: 5.5rem;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    box-sizing: border-box;
    padding-bottom: .4rem;
    font-size: 1.45rem;
    font-weight: 600;
    color: #130555;
  }

  .liveStreamingBtn img {
    margin-top: .3rem;
    width: 1.85rem;
    margin-right: .4rem;
  }

  .giftBtn {
    width: 17.6rem;
    height: 5.5rem;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding-bottom: .4rem;
    font-size: 1.75rem;
    font-weight: 600;
    color: #130555;
  }

  .giftBtn img {
    width: 1.75rem;
    margin-right: .4rem;
  }

  .giftBtnType {
    transform: scale(1.1);
  }

  /* 登录 */
  .loginCard {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
  }

  .loginCon {
    width: 31rem;
    height: 43.3rem;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: 0 1.6rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }

  .phoneInput {
    width: 100%;
    height: 4.7rem;
    border-radius: 4.7rem;
    border: none;
    background-color: #FFFFFF;
    box-sizing: border-box;
    padding: 0 2.5rem;
    font-size: 1.5rem;
    color: #8AA9D8;
    outline: none;
    margin-bottom: 1.4rem;
  }

  .phoneInput[name="phoneInput"]::-webkit-input-placeholder {
    color: #81A2D5;
  }

  .securityCodeInput {
    display: flex;
    height: 4.7rem;
    margin-bottom: 4.3rem;
  }

  .securityCodeInput input {
    width: 65%;
    border-radius: 4.7rem 0 0 4.7rem;
    border: none;
    background-color: #FFFFFF;
    box-sizing: border-box;
    padding: 0 2.5rem;
    font-size: 1.5rem;
    color: #8AA9D8;
    outline: none;
  }

  .securityCodeInput p {
    width: 35%;
    border-radius: 0 4.7rem 4.7rem 0;
    background-color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: 1.4rem;
    color: #F7443F;
    padding-right: 2rem;
  }

  .securityCodeInput input[name="securityCode"]::-webkit-input-placeholder {
    color: #81A2D5;
  }

  .beginBtn {
    width: 100%;
    height: 4.7rem;
    border-radius: 4.7rem;
    background: #FFFFFF;
    margin-bottom: 3.65rem;
    font-size: 1.8rem;
    font-weight: 600;
    color: #81A2D5;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  /* 举报 */
  .informerHint {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .informerCon {
    width: 30rem;
    height: 19.3rem;
    background-color: #FFFFFF;
    border-radius: 1rem;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  .informerInfo {
    font-size: 1.6rem;
    color: #1D2023;
  }

  .informerClose {
    width: 22.6rem;
    height: 4.4rem;
    background: linear-gradient(170deg, #FFCC76, #FF9A4D);
    margin-top: 2.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4.4rem;
    color: #642207;
    font-size: 1.8rem;
    font-weight: 600;
  }

  /* 加群 */
  .addGroupHint {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .groupCon {
    box-sizing: border-box;
    width: 31rem;
    height: 33rem;
    background-color: #FFFFFF;
    border-radius: .5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    flex-direction: column;
    padding: 0 1rem;
  }

  .groupCon div {
    font-size: 1.7rem;
    color: #333333;
    font-weight: 600;
  }

  .groupCon img {
    width: 17rem;
    height: 17rem;
    margin-top: 1.7rem;
    margin-bottom: 1rem;
  }

  .groupCon p {
    font-size: 1.4rem;
    color: #333333;
  }

  /* 打开app */
  .callApp {
    position: fixed;
    right: 0;
    bottom: 20rem;
    z-index: 9;
  }

  .callApp img {
    width: 9.55rem;
    height: 6.25rem;
  }
</style>
